<i18n>
    {
    "en": {
    "section_title": "Settings",
    "saved_settings": "Settings have been saved"
    },
    "ua": {
    "section_title": "Налаштування",
    "saved_settings": "Налаштування збережені"
    },
    "ru": {
    "section_title": "Настройки",
    "saved_settings": "Настройки сохранены"
    }
    }
</i18n>

<template>
  <el-col>
    <section-divider icon="el-icon-s-tools" :text="$t('section_title')" />
    <settings-block
      style="margin: 0 20px"
      :script="script"
      :custom-fields="customFields"
      show-embedded-code
      @onSave="
        v =>
          v
            .save()
            .then(() =>
              $notify({ type: 'success', message: this.$t('saved_settings') })
            )
            .catch(() => {})
      "
    />
  </el-col>
</template>

<script>
import SectionDivider from "../SectionDivider";
import SettingsBlock from "../../../scripts/settings-block";
import { mapGetters } from "vuex";
export default {
  name: "script-settings-section",
  components: { SettingsBlock, SectionDivider },
  props: {
    service: Object
  },
  methods: {
    handleSaveSharedScripts(script) {
      script.save();
    }
  },
  computed: {
    script() {
      return this.service._embedded.sharedScripts;
    },
    ...mapGetters({
      _amoAccount: "cache/amo_accounts/account"
    }),
    amoAccount() {
      return this._amoAccount(this.service._embedded.sharedAmocrm);
    },
    customFields() {
      try {
        return this.amoAccount.customFields(v => v.field_type === 1, [
          "lead",
          "contact"
        ]);
      } catch (e) {}
      return {};
    }
  }
};
</script>

<style scoped></style>
